import React from 'react';
import { connect } from 'react-redux';
import { Event } from '../../socketProvider';

import { setCameraStatus } from '../../store/actions/cameras';
import { setFirstSrs } from '../../pages/Monitor/actions';
import { socketEventNames } from '../../helpers/constants';

const {
  MONITOR_POWER_CAMPOOL,
  MONITOR_FIRST_SRS,
} = socketEventNames;

const mapCamStatus = (action) => (cam, status) => action({ [cam]: (status ? 'on' : 'off') });

const GlobalSocketEvents = ({ setCameraStatusAction, setFirstSrsAction }) => (
  <>
    <Event event={MONITOR_POWER_CAMPOOL} handler={mapCamStatus(setCameraStatusAction)} />
    <Event event={MONITOR_FIRST_SRS} handler={setFirstSrsAction} />
  </>
);

export default connect(
  null,
  {
    setCameraStatusAction: setCameraStatus,
    setFirstSrsAction: setFirstSrs,
  },
)(GlobalSocketEvents);
